import { useEffect } from 'react';
import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const ProjectEstimator = dynamic(() =>
  import('modules/contact/ProjectEstimator').then(mod => mod.ProjectEstimator),
);

const ProjectEstimationPage = () => {
  const { t } = useTranslation('meta');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  const seo = {
    alternate: t('projectEstimation.alternate', { returnObjects: true }),
    description: t('projectEstimation.description'),
    image: t('projectEstimation.image'),
    slug: t('projectEstimation.slug'),
    title: t('projectEstimation.title'),
  };

  return (
    <Layout dark seo={seo}>
      <ProjectEstimator />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IProjectEstimationPageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pageProjectEstimator',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IProjectEstimationPageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default ProjectEstimationPage;
